import React from "react";
import { Link } from "react-router-dom";
import { useWishlist } from "../../context/WishlistContext";

import { Favorite } from "@mui/icons-material";

const WishModal = () => {
  const { getTotalWish, wishlistItems } = useWishlist();

  return (
    <div className="relative group inline-block ">
      <Link to="/settings/wishlist" className="  hover:text-white">
        <Favorite fontSize="small" />
        <span className="absolute -top-2 right-0 bg-red-500 text-white rounded-full text-small w-4 h-4 flex items-center justify-center">
          {getTotalWish()}
        </span>
      </Link>

      <div
        className="opacity-0 group-hover:opacity-100 invisible group-hover:visible absolute -left-32 transform -translate-x-1/2
             top-full z-10 w-80 p-4 bg-white border border-gray-300 rounded-tl-3xl rounded-br-3xl  shadow-lg transition-opacity duration-300 ease-in-out"
      >
        <div className="cart-arrow"></div>

        <h3 className="text-lg font-semibold border-b-2 border-coffee text-black mb-2">
          Wishlist
        </h3>

        {wishlistItems.length === 0 ? (
          <p className="text-center text-black py-8 ">
            Your wishlist is empty.
          </p>
        ) : (
          <ul>
            {wishlistItems.map((item) => (
              <li key={item.id} className="mb-4 items-center">
                <div className="flex items-center">
                  {item.imageUrls && item.imageUrls.length > 0 && (
                    <img
                      key={item.id}
                      src={item.imageUrls[0]}
                      alt={item.title}
                      className="w-12 h-12 object-cover mr-4"
                    />
                  )}

                  <div className="text-black">
                    <p className="text-small truncate overflow-hidden w-40">
                      {item.name}
                    </p>
                  </div>
                  <div className="text-black flex justify-between items-center ">
                    <p className="text-small p-2">
                      Gh₵ {item.price.toLocaleString()}
                    </p>
                  </div>
                </div>
              </li>
            ))}
            <div className=" mt-4">
              <Link
                to="/settings/wishlist"
                className="mt-4 ml-2 text-small bg-coffee text-white p-2 rounded hover:text-white"
              >
                View Wishlist
              </Link>
            </div>{" "}
          </ul>
        )}
      </div>
    </div>
  );
};

export default WishModal;
